import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const deliveryOrderModule = () => import('./delivery-order.module').then((m) => m.DeliveryOrderModule);

export const deliveryOrderRoutes: Routes = [
  {
    path: 'delivery-order',
    canActivateChild: [RoleGuard],
    loadChildren: deliveryOrderModule,
    data: {
      enum: 'DELIVERY_ORDER',
      label: 'Delivery Order',
      icon: 'ic_delivery.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'LIST_DELIVERY_ORDER',
          label: 'List Delivery Order',
          path: 'delivery-order/list',
          children: [],
        },
      ],
    },
  },
];
